import {forwardRef, HTMLAttributes} from 'react';
import styled from 'styled-components';

interface Props extends HTMLAttributes<HTMLDivElement> {}

const AutoTitle = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <div
    title={typeof props.children === 'string' ? props.children : undefined}
    {...props}
    ref={ref}
  />
));

const Title = styled(AutoTitle)`
  font-size: var(--theme-font-size-title);
  font-weight: var(--theme-font-weight-title);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TruncatedTitle = styled(Title)`
  line-height: 1;
  white-space: nowrap;
`;

export const PageTitle = styled(Title)`
  font-size: var(--theme-font-size-page-title);
  white-space: nowrap;
  max-width: 30vw;
  line-height: 1.2;
  min-width: 6.25rem;
`;

export default Title;
